import StructFunctionality, { forget } from "./StructFunctionality";
const item = 'settings';

export default function SettingStruct ( settings )
{ return StructFunctionality( {}, settings, item ); }

export function forget_settings (  )
{ forget( item ); }
